var advance = function() {
  document.querySelectorAll('.grid-meta-color li').forEach((color) => {
    color.addEventListener('mouseover',function(){
      if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.querySelector('img').getAttribute('src'))
      }
    })
    color.addEventListener('mouseout',function(){
      if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.closest('.grid-meta-color').querySelector('li a.active img').getAttribute('src'))
      }
    })
  });
  $th_refreshWishlistItems();
}
var infinitescroll = {
  instance: null,
  scolljs: function(){
    var productGrid = document.querySelector('#product-grid');
    var pagination = document.querySelector('#AjaxinatePagination');
    
    if (!productGrid || !pagination) {
      return;
    }
    
    if (this.instance && typeof this.instance.destroy === 'function') {
      this.instance.destroy();
    }
    
    this.instance = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      callback: advance,
      offset:1000
    });
  }
}

infinitescroll.scolljs();

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    infinitescroll.scolljs();
  }
});

document.addEventListener('scroll', function(e) {
  var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
  sessionStorage.scrollPos = document.documentElement.scrollTop;
  sessionStorage.totalpage = totalpage;
});

if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
  var scrollTop = sessionStorage?.getItem('scrollPos');
  
  setTimeout(function() {
    var buttonTop = document.querySelector('#AjaxinatePagination');
    
    if (!buttonTop) {
      if (scrollTop) {
        window.scrollTo(0, parseInt(scrollTop));
      }
      return;
    }
    
    var buttonScroll = buttonTop.offsetTop - window.scrollY;
    
    if (scrollTop && buttonScroll < parseInt(scrollTop)) {
      var triggerScroll = buttonTop.offsetTop - 1200;
      window.scrollTo(0, triggerScroll);
      
      setTimeout(function checkAndScroll() {
        buttonTop = document.querySelector('#AjaxinatePagination');
        if (buttonTop) {
          var newButtonOffset = buttonTop.offsetTop;          
          if (newButtonOffset > parseInt(scrollTop)) {
            window.scrollTo(0, parseInt(scrollTop));
          } else {
            window.scrollTo(0, newButtonOffset - 1200);
            setTimeout(checkAndScroll, 1000);
          }
        } else {
          window.scrollTo(0, parseInt(scrollTop));
        }
      }, 1000);
    } else {
      window.scrollTo(0, parseInt(scrollTop || 0));
    }
  }, 300);
}


let filter = document.querySelector("facet-filters-form").offsetTop;
var lastscroll = 0;
window.addEventListener("scroll", () => {
  let scrollcount = window.pageYOffset;
  (scrollcount >= filter) ? document.querySelector('body').classList.add("filter-sticky") : document.querySelector('body').classList.remove("filter-sticky")
  setTimeout(function(){
    if(scrollcount > lastscroll){
      document.querySelector('.snippet-collection-filter').style.top = '0px'
    }else if(scrollcount < lastscroll){
      if(window.innerWidth < 992){
      document.querySelector('.snippet-collection-filter').style.top = document.querySelector('.header-group').clientHeight - 35 +'px'
      }else{
        document.querySelector('.snippet-collection-filter').style.top = document.querySelector('.header-group').clientHeight - 40 +'px' 
      }
      // console.log(scrollcount,'---',window.pageYOffset,'---',window.outerHeight)
      // document.querySelector('.snippet-collection-filter').style.top = document.querySelector('.snippet-collection-filter').style.top + 8+'px'
      // if(scrollcount >= document.querySelector('.header-main').clientHeight){
      //   document.querySelector('.snippet-collection-filter').style.top = scrollcount + 'px'
      // }
    }
    lastscroll = scrollcount;
  }, 100);
});